export enum EFinancialIds {
  CHART_OF_ACCOUNTS = 'chart-of-accounts',
  CARD_AGREEMENTS = 'card-agreements',
  DISCOUNTS = 'discounts',
  BANK_ACCOUNTS = 'bank-accounts',
  FINES = 'fines',
}

export const financialPageFragments = [
  {
    title: 'FINANCIAL.CHART_OF_ACCOUNTS.CHART_OF_ACCOUNTS',
    id: EFinancialIds.CHART_OF_ACCOUNTS,
  },
  {
    title: 'FINANCIAL.CARD_AGREEMENTS.CARD_AGREEMENTS',
    id: EFinancialIds.CARD_AGREEMENTS,
  },
  {
    title: 'FINANCIAL.DISCOUNTS.DISCOUNTS',
    id: EFinancialIds.DISCOUNTS,
  },
  {
    title: 'FINANCIAL.BANK_ACCOUNTS.BANK_ACCOUNTS',
    id: EFinancialIds.BANK_ACCOUNTS,
  },
  {
    title: 'FINANCIAL.FINES.FINES',
    id: EFinancialIds.FINES,
  }
];